import * as React from 'react';

import {Button} from 'shells/button/button';
import {Body} from 'shells/typography/body';

type Props = {
    text: string;
    ctaText: string;
    onClick: () => void;
};

export function PopoverSectionHeader(props: Props) {
    return (
        <div className='flex align-center justify-sb '>
            <Body size='small' isBold={true}>
                {props.text}
            </Body>
            <Button variant='text-primary' size='small' noPadding={true} onClick={props.onClick}>
                {props.ctaText}
            </Button>
        </div>
    );
}
